/*
 * Functions for setting up the Custom Resource Report filters.
 */

(function (c2, $) {
  'use strict';

  function saveReport(url) {
    $('button').prop('disabled', true);
    var $form = $('form#custom-resource-report-form');
    var data = $form.serializeArray();
    data.push({name: 'report_model', value: 'RESOURCE'});

    $.post(url, data, c2.customReportCommon.handleResponse);
  }

  /**
   * Run the Report by posting all form data. If format is not specified, requests 'json' which
   * causes the report view to return JSON data as table HTML. If 'csv' format is specified,
   * the report view returns CSV data and a file download is triggered.
   */
  function runReport(url, format) {
    $('button').prop('disabled', true);
    var $form = $('form#custom-resource-report-form');
    var data = $form.serializeArray();
    data.push({name: 'format', value: format || 'json'});

    c2.spinners.showSpinner({selector: '#report-container'});
    $.post(url, data, c2.customReportCommon.handleResponse);
  }

  window.c2.customResourceReport = {
    runReport: runReport,
    saveReport: saveReport,
  };

})(window.c2, window.jQuery);
